import { getUserMailboxInfo } from 'owa-client-ids';
import type { CalendarId } from 'owa-graph-schema';
import { getOWAConnectedAccounts } from 'owa-accounts-store';

/**
 * Checks to see if calendar belongs to primary connected account
 * @param calendar the Calendar to check
 * @returns {boloean} true if the Calendar belongs to the primary connected account
 */
export function isPrimaryCalendar(calendarId: CalendarId) {
    const defaultUserId = getUserMailboxInfo().userIdentity;
    return calendarId.mailboxInfo.userIdentity == defaultUserId;
}

export function getSortedCalendarsMap(calendars) {
    if (getOWAConnectedAccounts().length === 0) {
        return calendars;
    }
    let sortedCalendars = new Object();

    Object.keys(calendars).map(id => {
        // add the first entry of map, all "Selected Calendars" option
        if (calendars[id]?.name && !calendars[id].calendarId) {
            Object.defineProperty(sortedCalendars, id, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: {
                    name: calendars[id].name,
                    calendarId: calendars[id].calendarId,
                },
            });
        }

        // add calendars connected to primary account
        if (
            calendars[id]?.name &&
            calendars[id]?.calendarId &&
            isPrimaryCalendar(calendars[id]?.calendarId)
        ) {
            Object.defineProperty(sortedCalendars, id, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: {
                    name: calendars[id].name,
                    calendarId: calendars[id].calendarId,
                },
            });
        }
    });

    Object.keys(calendars).map(id => {
        // add calendars connected to secondary account
        if (
            calendars[id]?.name &&
            calendars[id]?.calendarId &&
            !isPrimaryCalendar(calendars[id]?.calendarId)
        ) {
            Object.defineProperty(sortedCalendars, id, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: {
                    name: calendars[id].name,
                    calendarId: calendars[id].calendarId,
                },
            });
        }
    });

    return sortedCalendars;
}
